import React from "react";
import { useTranslation } from "react-i18next";
import { getRoleName } from "../../Constants/Roles";
import { getRandomNumber } from "../../Helpers/utils/utils";
import { hasValue } from "../../Helpers/validations/common";
import "./UserInfoData.scss";

const UserInfoData = ({ userInfo }) => {
  const [t] = useTranslation();

  const renderInfoRow = (x, key) => {
    return (
      x && (
        <div className="info-row" key={"info-" + getRandomNumber() + "-" + key}>
          <div className="key">{x.key}</div>
          <div className="value">{hasValue(x.value) ? x.value : "-"}</div>
        </div>
      )
    );
  };

  const userInfoData = [
    {
      key: t("Name"),
      value: `${userInfo.firstName} ${userInfo.preposition} ${userInfo.lastName}`,
    },
    {
      key: t("Preposition"),
      value: `${userInfo.preposition}`,
    },
    {
      key: t("LastName"),
      value: `${userInfo.lastName}`,
    },
    { key: t("Email"), value: userInfo.email },
    {
      key: t("Role"),
      value: `${t(getRoleName(userInfo.role))} (${getRoleName(userInfo.role)})`,
    },
    userInfo.isExternalUser && {
      key: "",
      value:  t("UserIsExternal"),
    },
  ];

  return (
    <div className="user-info-data">
      <div className="subtitle">{t("UserInfo")}</div>
      <div className="info-wrapper">
        {userInfoData.map((x) => renderInfoRow(x, "userData"))}
      </div>
    </div>
  );
};

export default UserInfoData;
